import React from 'react';
import toast, {useToaster} from 'react-hot-toast';

import Status from 'components/Status';

import AdvancedAlertBox from './AdvancedAlertBox';

function AlertStack(props) {
	const {toasts: alerts, handlers} = useToaster({
		reverseOrder: true,
		duration: 4000,
	});
	const {startPause, endPause} = handlers;
	const visibleAlerts = alerts.filter(alert => alert.visible);

	return (
		<Status
			{...props}
			z="alerts"
			onMouseEnter={startPause}
			onMouseLeave={endPause}
		>
			{visibleAlerts.map(({data: alert, id}) => {
				const alertId = alert.key || id;
				return (
					<AdvancedAlertBox
						key={alertId}
						title={alert.title}
						description={alert.message}
						type={alert.type}
						progress={alert.progress}
						message={alert.message}
						cta={alert.cta}
						onClose={() => toast.dismiss(alertId)}
					/>
				);
			})}
		</Status>
	);
}

export default AlertStack;
